import Create from './create'
export default {
  name: 'category-checklist',
  components: {Create},
  props: [],
  data () {
    return {
      loading: true,
      updateItem: {},
      selectCtg:{},
      checklistCtg:[],
      btn_submit: false,
      errors: {},
      normalizer_ctg (node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        }
      },
    }
  },
  computed: {
    category () {
      return this.$store.getters['CategoryChk/getListCTG']
    },
    categoryRecursive () {
      return this.$store.getters['CategoryChk/getListRecursive']
    },
    checklistAll () {
      return this.$store.getters['Checklist/getListChecklistAll']
    },
  },
  mounted () {
    this.loading = true
    this.$loading.start()
    Promise.all([
      this.category.length ==0 ?this.$store.dispatch('CategoryChk/getListCtg'):'',
      this.checklistAll.length ==0 ? this.$store.dispatch('Checklist/getListChecklistAll', {page: 1, per_page: 5000, sort: 'desc'}):''
    ]).then(res => {
      this.loading = false
      this.$loading.complete()
    }).catch(errors => {
      this.loading = false
      this.$loading.fail()
    })
  },
  methods: {
    selectChk(ctg){
      this.$refs.selectForm.show()
      this.selectCtg = ctg
      this.checklistCtg = this.checklistAll
      this.checklistCtg.forEach(item =>{
        if(item.category.id == ctg.id){
          item.select = true
        }else{
          item.select =false
        }
      })
    },
    select(){
      var data = []
      this.checklistCtg.forEach(item => {
        if(item.select){
          data.push(item.id)
        }
      })
      this.$loading.start()
      this.$store.dispatch('CategoryChk/selectCtg', {ctg: this.selectCtg,chks: data}).then(res => {
        this.$loading.complete()
        this.$store.dispatch('Checklist/selectCtg',{ctg: this.selectCtg,chks: data})
        this.$refs.selectForm.hide()
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.$loading.fail()
      })
    },
    update () {
      this.updateItem.default = 'false'
      this.$loading.start()
      this.$store.dispatch('CategoryChk/updateCtg', {ctg: this.updateItem}).then(res => {
        this.$refs.updateForm.hide()
        this.$loading.complete()
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.$loading.fail()
      })
    },
    showModalEdit(ctg){
      this.$refs.updateForm.show()
      this.updateItem = ctg
    },
    destroy(ctg){
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
            this.$loading.start()
            this.$store.dispatch('CategoryChk/destroyCtg', {
              ctg: ctg
            }).then((res) => {
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
              this.$loading.complete()
            }).catch(errors => {
              this.$loading.complete()
            })
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/category-checklist/category-checklist.js